(function ($) {
  Drupal.behaviors.formFields = {
		    attach: function (context) {
		    		Drupal.behaviors.formFieldsCreator(context);
		    }
	};

Drupal.behaviors.formFieldsCreator = function (context) {
	$(".formField", context).each(function (index){
		var mainContent = $(this);
    	var isAlreadyModified = $(mainContent).data("saph-done");
    	if(isAlreadyModified){
    		return true;
    	}

		//Textfield
    	$(".formField-textField",mainContent).each(function (index){
    		var elementContent = $(this);
    		//var fullWidth = $(".formField-mainContent",mainContent).width();
    		/*
		    if ($(".formField-textField-input",elementContent).val().length <= 0) {
    		    		$(".formField-textField-label",elementContent).addClass("top-16-important");
			}


    		$( elementContent )
  		  .focusout(function() {
  			  Drupal.behaviors.functions.consolog("No longer focus");
  			  if ($(".formField-textField-input",elementContent).val().length <= 0) {
		    		    $(".formField-textField-label",elementContent).addClass("top-16-important");
  				}
  		  })
  		  .focusin(function() {
  			  Drupal.behaviors.functions.consolog("Now in focus");
  			  $(".formField-textField-label",elementContent).removeClass("top-16-important");
  		  });
    		$(".formField-textField-label",elementContent).click(function() {
    			$(".formField-textField-input",elementContent).focus();
    		});
    		$(".formField-textField-input",elementContent).focus();
    		*/
    		/*
		    setTimeout(function(){
		    	Drupal.behaviors.functions.consolog("Timeout called");
		    	$(".formField-textField-input",elementContent).focus();
	  			  //if ($(".formField-textField-input",elementContent).val().length > 0) {
		    		  //  $(".formField-textField-label",elementContent).removeClass("top-16-important");
			  //}
		    	}, 500);
		    	*/
    	});

    	//MultiTextField
    	$(".formField-multiTextField",mainContent).each(function (index){
    		var fullWidth = $(".formField-mainContent",mainContent).width();
    		var elementContent = $(this);
    		var maxAmountLength = $(".formField-multiTextField-input",elementContent).attr('maxlength');
    		var currentLength = $(".formField-multiTextField-input",elementContent).val().length;
    		var textForCharactersLeft = $(elementContent).data("characters-left-text");
    		$(".formField-charactersLeft",elementContent).text("" + (maxAmountLength-currentLength) + " " + textForCharactersLeft)


	    	$(elementContent).keyup(function() {
	    		//var internalField = $(this);
	    		maxAmountLength = $(".formField-multiTextField-input",elementContent).attr('maxlength');
	    		currentLength = $(".formField-multiTextField-input",elementContent).val().length;
	    		//textForCharactersLeft = $(elementContent).data("characters-left-text");
	    		$(".formField-charactersLeft",elementContent).text("" + (maxAmountLength-currentLength) + " " + textForCharactersLeft)
	    	});

	    $(".formField-multiTextField-input",elementContent).change(function() {
	    		var internalField = $(this);
	    		maxAmountLength = $(internalField).attr('maxlength');
	    		currentLength = $(internalField).val().length;
	    		//textForCharactersLeft = $(elementContent).data("characters-left-text");
	    		$(".formField-charactersLeft",elementContent).text("" + (maxAmountLength-currentLength) + " " + textForCharactersLeft)
	    	});
    	});

		//Drop
    	$(".formField-dropField",mainContent).each(function (index){
    		var elementContent = $(this);
    		var fullWidth = $(".formField-dropField-input",elementContent).width();
    		var fullHeight = $(".formField-dropField-input",elementContent).height();
    		var bgWidth = 24, bgHeight = 24;
    		//$(".formField-dropField-input",elementContent).css({"background-position": (fullWidth-bgWidth-5) + "px " + "center"});

		    if ($(".formField-dropField-input select option:selected",elementContent).text().length <= 0) {
    		    $(".formField-dropField-label",elementContent).addClass("top-16-important");
			}

		    $(".formField-dropField-input select",elementContent).change(
		    		function() {
		    			  if ($("option:selected", this).text().length <= 0) {
		    				  $(".formField-dropField-label",elementContent).addClass("top-16-important");
	    				}else{
	    					$(".formField-dropField-label",elementContent).removeClass("top-16-important");
	    				}
		    		});
    	});

		//Checkbox
    	$(".formField-checkbox",mainContent).each(function (index){
    		var elementContent = $(this);
    		$(".formField-checkbox-image, .formField-checkbox-whiteImage",elementContent).height($(".formField-checkbox-label",elementContent).css('line-height'));
    		/*
    		elementContent.click(function() {
    			$('.formField-checkbox-field',this).prop('checked', !($('.formField-checkbox-field',this).prop('checked')));
    		  	$(".formField-checkbox-image",this).toggleClass( "checked" );
			});
			*/
    	});

		//Radio
    	$(".formField-radio",mainContent).each(function (index){
    		var elementContent = $(this);
    		//formField-radio-image
    		//formField-radio-label
    		$(".formField-radio-image",elementContent).height($(".formField-radio-label",elementContent).css('line-height'));
    		/*
    		elementContent.click(function() {
    			$('.formField-radio-field',this).prop('checked', !($('.formField-radio-field',this).prop('checked')));
    		  	$(".formField-radio-image",this).toggleClass( "checked" );
			});
			*/
    	});

		//File load field
    	$(".formField-fileLoader",mainContent).each(function (index){
    		var elementContent = $(this);
		var textForNoFile = $(".formField-fileLoader-text",elementContent).data("no-file-text");
		var inputTextElement = $(".formField-fileLoader-text",elementContent);

    		$(".formField-fileLoader-text",elementContent).height($(".formField-fileLoader-text",elementContent).css('line-height'));
    		$(".formField-fileLoader-input",elementContent).on( 'change', function( e )
    			{
    					var fileName = '';
    					if( this.files && this.files.length > 1 )
    						fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
    					else if( e.target.value )
    						fileName = e.target.value.split( '\\' ).pop();

    					if( fileName ){
    						$(".formField-fileLoader-deleteButton",elementContent).removeClass("hideElement");
    						$(inputTextElement).html( fileName );
    					}else{
    						$(".formField-fileLoader-deleteButton",elementContent).addClass("hideElement");
    						$(inputTextElement).html( textForNoFile );
    					}
    		});
    		$(".formField-fileLoader-deleteButton",elementContent).click(function() {
    			   var $el = $(elementContent);
    			   $el.wrap('<form>').closest('form').get(0).reset();
    			   $el.unwrap();
    			   $(".formField-fileLoader-deleteButton",elementContent).addClass("hideElement");
    			   $(inputTextElement).html( textForNoFile );
    		});
    	});
    	//formField-bigplus-add-achievement
    	$(".formField-bigplus-add-achievement",mainContent).each(function (index){
    		var elementContent = $(this);
    		$(".formField-bigplus-add-achievement-text",elementContent).height($(".formField-bigplus-add-achievement-text",elementContent).css('line-height'));
    	});

    	//PhotoLoader
    	$(".formField-photoLoader",mainContent).each(function (index){
    		var elementContent = $(this);
    		var fullWidth = $(window).width();
    		var imageServerURL = $(elementContent).data("image-server-url");
    		var imageSectionName = $(elementContent).data("image-section-name");

    		$('.formField-photoLoader-button', elementContent).css({"width": "100%"})
    		//$(".formField-photoLoader-button", elementContent).css({"min-width": (fullWidth * 0.22) + "px"});
    		$(".formField-photoLoader-button-label",elementContent).height($(".formField-photoLoader-button-label",elementContent).css('line-height'));

    		$(".formField-photoLoader-input",elementContent).on( 'change', function( e ){
				var elementWidth = $(elementContent).width();

				if(this.files && this.files.length > 0) {

					$(".preloader").show();

					var fileName = e.target.files[0].name;
					var fileExt = fileName.split(".").pop().toLowerCase(); //.substring(0,3);
					if(fileExt.indexOf("?") >= 0){
						fileExt = fileExt.substring(0,fileExt.indexOf("?"));
					}

					Drupal.behaviors.functions.consolog("file loading... => filename:" + fileName);
					Drupal.behaviors.functions.consolog("file loading... => fileext:" + fileExt);

					elementContent.attr("data-fileext", fileExt);

					var fallbackImage = elementContent.find('.formField-photoLoader-photo').attr("data-fallback-image");

					var fileError = false;

					elementContent.parent(".formField").removeClass("formField-error");
					elementContent.find(".formField-error-message").hide();

					//file extention check
					if($(this).attr("accept") != ""){
						var extArray = $(this).attr("accept").split(",");
						for (var i = 0; i < extArray.length; i++) {
							const element = extArray[i];
							extArray[i] = element.replace(" ", "").replace(".", "");
						}
						if(extArray.indexOf(fileExt) < 0){
							Drupal.behaviors.functions.consolog("wrong file selected!!!");
							fileError = true;

							//show fallback image
							elementContent.find('.formField-photoLoader-photo').removeClass("hideElement");
							elementContent.find('.formField-photoLoader-photo').addClass("hideElement");
							elementContent.find('.formField-photoLoader-photo').html("");

							//show error message
							elementContent.parent(".formField").removeClass("formField-error");
							elementContent.parent(".formField").addClass("formField-error");
							var $clientFiletypeMsg = elementContent.find(".formField-error-message.filetype");
							$clientFiletypeMsg.text($clientFiletypeMsg.data("default-text"));
							$clientFiletypeMsg.show();

							elementContent.siblings("input[type='hidden']").remove();
							elementContent.find(".formField-photoLoader-button").css("width", "100%");
						}
					}

					if(!fileError){
						var imageLoaded = this.files[0];
						var reader = new FileReader();
						var label = elementContent.find(".formField-photoLoader-button-label").html();
						reader.onloadstart = function (e) {
							Drupal.behaviors.functions.consolog("formField-photoLoader EVENT onloadstart");
							elementContent.removeClass("loading");
							elementContent.addClass("loading");

							//file size check
							if (e.lengthComputable) {
								var maxFilesize = parseInt(elementContent.find(".formField-photoLoader-input").attr("data-max-filesize"));
								if(e.total > maxFilesize){
									e.target.abort();

									elementContent.attr("data-filesize", e.total);

									//show fallback image
									elementContent.find('.formField-photoLoader-photo').removeClass("hideElement");
									elementContent.find('.formField-photoLoader-photo').addClass("hideElement");

									//show error message
									elementContent.parent(".formField").removeClass("formField-error");
									elementContent.parent(".formField").addClass("formField-error");

									elementContent.find(".formField-error-message.filesize").children("span").html((maxFilesize/1000000)+"");
									elementContent.find(".formField-error-message.filesize").show();

									elementContent.removeClass("loading");

									elementContent.siblings("input[type='hidden']").remove();
									elementContent.find(".formField-photoLoader-button").css("width", "100%");

									$(".preloader").hide();
								}
							}
						}
						reader.onprogress = function (e) {
							Drupal.behaviors.functions.consolog("formField-photoLoader EVENT onprogress");
							if (e.lengthComputable) {
								var progress = parseInt( ((e.loaded / e.total) * 100), 10 );
								//Drupal.behaviors.functions.consolog("formField-photoLoader EVENT onprogress => " + progress);
								elementContent.find(".formField-photoLoader-button-label").html(progress + "%");
								elementContent.attr("data-filesize", e.total);
							}
						}
						reader.onload = function (e) {
							Drupal.behaviors.functions.consolog("formField-photoLoader EVENT onload");
							elementContent.removeClass("loading");
							elementContent.find(".formField-photoLoader-button-label").html(label);

							if(fileExt == "jpg" || fileExt == "png" || fileExt == "jpeg"){
								elementContent.find('.formField-photoLoader-photo',elementContent).css('background-image', 'url(' + e.target.result + ')');
								elementContent.find('.formField-photoLoader-photo').html("");
							}
							else{
								elementContent.find('.formField-photoLoader-photo',elementContent).css('background-image', 'url(' + fallbackImage + ')');
								elementContent.find('.formField-photoLoader-photo').html(fileExt);
							}

							elementContent.find('.formField-photoLoader-photo',elementContent).removeClass("hideElement");
							elementContent.find('.formField-photoLoader-button', elementContent).css({"width": "calc(100% - 56px - 18px)"})
							//$('.formField-photoLoader-button', elementContent).width("calc(100% - 56px -18px)");

							//Send the image
							Drupal.behaviors.functions.consolog("Appending Image:" + imageLoaded.name);
							var formData = new FormData();
							formData.append(imageLoaded.name, imageLoaded)
							$.ajax({
							url: imageServerURL, 		// Url to which the request is send
							type: "POST",             	// Type of request to be send, called as method
							data: formData, 			// Data sent to server, a set of key/value pairs (i.e. form fields and values)
							contentType: false,       	// The content type used when sending data to the server.
							cache: false,             	// To unable request pages to be cached
							processData:false,        	// To send DOMDocument or non processed data file it is set to false
							success: function(data)   	// A function to be called if request succeeds
								{
									Drupal.behaviors.functions.consolog("information loaded:" + data);

                  //console.log("photoloader upload done!");

									//Remove the hidden element
									$("input[data-uploaded-picture-name='" + imageSectionName + "']").remove();

									//Add new field
									if(data["data"].length > 0){
                    var loadedImageID = data["data"][0]["id"];

                    //add hidden field
                    var $hiddenUploadField = $(elementContent).before('<input type="hidden" data-uploaded-picture-name="' + imageSectionName + '" name="' + imageSectionName + '" value="' + loadedImageID + '">');
										elementContent.attr("data-server-message", "");

                    $hiddenUploadField.trigger("change");
                    //console.log("photoloader upload done! $hiddenUploadField:" + $hiddenUploadField);

                    var $elementInputFile = $hiddenUploadField.siblings(".formField-photoLoader").find("input");
                    $elementInputFile.trigger("change");
                    //console.log("photoloader upload done! $elementInputFile:" + $elementInputFile);

                    //show footer
                    var $elementFooter = $hiddenUploadField.siblings(".formField-photoLoader-footer");
                    if($elementFooter){
                      //console.log("elementFooter:" + $elementFooter);
                      $elementFooter.removeClass("hideElement");

                      //add delete button click handling
                      var $elementDelete = $elementFooter.find(".formField-photoLoader-delete");
                      if($elementDelete){
                        $elementDelete.off().on("click", handlePhotouploadDeleteButton);
                      }
                    }

									}
									else if(data["message"].length > 0){
										var serverMessage = "(";
										var hasFiletypeError = false;
										for (var i = 0; i < data["message"].length; i++) {
											const code = data["message"][i]["code"];
											const message = data["message"][i]["msg"];
											if(code == 102){
												hasFiletypeError = true;
											}
											serverMessage += "code:" + code + " / message:" + message;
											if(i < data["message"].length-1){
												serverMessage += " # ";
											}
										}
										serverMessage += ")";
										elementContent.attr("data-server-message", serverMessage);

										//the server rejected the file (e.g. the real content did not match the
										//extension, such as an AVIF saved as .jpg) - surface it visually.
										//discard the local preview that was shown optimistically above.
										elementContent.find('.formField-photoLoader-photo').addClass("hideElement");
										elementContent.find('.formField-photoLoader-photo').html("");
										elementContent.find(".formField-photoLoader-button").css("width", "100%");

										//make sure no stale uploaded reference is submitted with the form
										$("input[data-uploaded-picture-name='" + imageSectionName + "']").remove();

										elementContent.parent(".formField").addClass("formField-error");
										if(hasFiletypeError){
											var $serverFiletypeMsg = elementContent.find(".formField-error-message.filetype");

											//the server reports the real content type it detected (e.g. "image/avif")
											//when a file was saved with a mismatched extension.
											var detectedType = (data["data"] && data["data"]["file_type"]) ? data["data"]["file_type"] : "";
											if(detectedType){
												$serverFiletypeMsg.text($serverFiletypeMsg.data("mismatch-text").replace("%type%", detectedType));
											}
											else{
												$serverFiletypeMsg.text($serverFiletypeMsg.data("default-text"));
											}
											$serverFiletypeMsg.show();
										}
									}

									$(".preloader").hide();
								},
							error : function(){
								//hide preloader on error
								Drupal.behaviors.functions.consolog("file loading... ERROR A");
								$(".preloader").hide();
							}
							});

						};
						reader.readAsDataURL(imageLoaded);
					}
					else{
						//hide preloader on error
						Drupal.behaviors.functions.consolog("file loading... ERROR B");
						$(".preloader").hide();
					}
				}
				else{
					//Now we don't remove the picture when cancelling
					//$('.formField-photoLoader-photo',elementContent).addClass("hideElement");
					//$('.formField-photoLoader-button', elementContent).width(elementWidth);
				}
        });
    		var preloadedImage = $(elementContent).data("preloaded-image");
    		if(preloadedImage){
    			Drupal.behaviors.setPictureOnPictureLoader(elementContent,preloadedImage);
    		}
    	});

    	//Back To Profile
    	$(".formField-backToProfileButton",mainContent).each(function (index){
    		var elementContent = $(this);
    		$(".formField-backToProfileButton-label",elementContent).height($(".formField-backToProfileButton-label",elementContent).css('line-height'));
    		$(elementContent).width($(".formField-backToProfileButton-image",elementContent).width() + $(".formField-backToProfileButton-label",elementContent).width() + 54);
    	});

    	//Big Button and medium button
    	$(".formField-bigButton, .formField-mediumButton",mainContent).each(function (index){
    		var elementContent = $(this);
    		var fullWidth = $(window).width();
    		//$(elementContent).css({"min-width": (fullWidth * 0.25) + "px"});
    		$(elementContent).css({"min-width": 279 + "px"});
    	});

    	$(".formField-singleLineCenterText", mainContent).each(function (index){
    		var elementContent = $(this);
    		var fullWidth = $(window).width();
    		$(".formField-singleLineCenterText-inner",elementContent).height($(".formField-singleLineCenterText-inner-text",elementContent).css('line-height'));
    	});

      //add upload delete button click handling
      $(".formField-photoLoader-footer").each(function(){
        var $elementDelete = $(this).find(".formField-photoLoader-delete");
        if($elementDelete){
          $elementDelete.off().on("click", handlePhotouploadDeleteButton);
        }
      })

      function handlePhotouploadDeleteButton(event){
        var $ed = $(event.target);
        var $ff = $ed.closest(".formField");


        //empty input file field
        $ff.find("input[type=file]").val("");
        $ff.find("input[type=file]").trigger("change");

        //remove hidden field
        $ff.find("input[type=hidden]").val("");
        $ff.find("input[type=hidden]").trigger("change");
        $ff.find("input[type=hidden]").remove();

        //hide footer
        if(!$ff.find(".formField-photoLoader-footer").hasClass("hideElement")){
          $ff.find(".formField-photoLoader-footer").addClass("hideElement");
        }

        //hide thumbnail
        var thumbnail = $ff.find(".formField-photoLoader-photo");
        if(thumbnail){
          thumbnail.css("background-image", "url();");
          if(!thumbnail.hasClass("hideElement")){
            thumbnail.addClass("hideElement");
          }
        }

        //resize button
        var button = $ff.find(".formField-photoLoader-button");
        if(button){
          button.css("width", "100%");
        }
      }

      $(mainContent).data("saph-done",true);
	});

	$("#tooltipContainer").click(function(){
		hideTooltip();
	});
	$(".formField").click(function(){
		hideTooltip();
	});
	$(window).scroll(function(){
		hideTooltip();
	});

	//Info buttons
	$(".tooltipInfoPoint, .tooltipInfoElement").each(function (index){

		if(!$(this).data("info-text")){
			return true;
		}

		//add click listener
		$(this).on("touchstart", function(event){
			event.preventDefault();

			//show tooltip on click if not already visible
			if($("#tooltipContainer").attr("data-info-text") != $(this).data("info-text")){
				showTooltip($(this));
			}
			else{
				hideTooltip();
			}

			if($(this).hasClass("formField-checkbox")){
				$(this).children("input[type='checkbox']").click();
			}

		});

		//add mouse listener
		$(this).mouseover(
			function() {
				  showTooltip($(this));

			}
		);
		$(this).mouseleave(
			function() {
				hideTooltip();
			}
		);
	});

	function showTooltip(element){
		var tooltipText = element.data("info-text");
		$("#tooltipContainer").attr("data-info-text", tooltipText);

		var maxWidth = $(window).width();
		$("#tooltipContainer").removeClass("hideElement");
		$("#tooltipContainer #tooltip-textSection").text(tooltipText);
		var tooltipPointLeft = element.offset().left-4;
		var tooltipPointTop = element.offset().top;
		var tooltipPointWidth = element.outerWidth(true);
		var heightOfTooltip = $("#tooltipContainer").height();
		var finalTooltipTop = tooltipPointTop - $(window).scrollTop() - heightOfTooltip;

		$("#tooltipContainer").css("top",finalTooltipTop);
		var widthOfTooltip = $("#tooltipContainer #tooltip-textSection").outerWidth(true);
		var finalTooltipLeft;
		if(tooltipPointLeft + (widthOfTooltip/2) + (tooltipPointWidth/2) > maxWidth){
			//has to be oriented to the left
			finalTooltipLeft = tooltipPointLeft - (widthOfTooltip) + tooltipPointWidth - 7;
		}
		else if(tooltipPointLeft - (widthOfTooltip/2) < 0){
			//has to be oriented to the right
			finalTooltipLeft = tooltipPointLeft;
		}
		else{
			//Can be in the center
			finalTooltipLeft = tooltipPointLeft - ((widthOfTooltip/2) - (tooltipPointWidth/2));
		}
		$("#tooltipContainer").css("left",finalTooltipLeft);
	}
	function hideTooltip(){
		$("#tooltipContainer").removeClass("hideElement");
		$("#tooltipContainer").addClass("hideElement");
		$("#tooltipContainer").attr("data-info-text", "");
	}
}

//Updating pictureLoader picture
Drupal.behaviors.setPictureOnPictureLoader = function (elementContent, image) {

	var imgPath = $(".formField-photoLoader-photo", elementContent).attr("data-fallback-image");
	var fileExt = image.split(".").pop().toLowerCase(); //.substring(0,3);
	if(fileExt.indexOf("?") >= 0){
		fileExt = fileExt.substring(0,fileExt.indexOf("?"));
	}

	if(image && (fileExt == "jpg" || fileExt == "png" || fileExt == "jpeg")){
		imgPath = image;
		$(".formField-photoLoader-photo", elementContent).html("")
	}
	else{
		$(".formField-photoLoader-photo", elementContent).html(fileExt);
	}

	//Drupal.behaviors.functions.consolog("Set picture on picture loader // image:" + image + " ext:" + fileExt);

	$(".formField-photoLoader-photo",elementContent).css("background-image", "url('" + imgPath + "')");
	$(".formField-photoLoader-photo",elementContent).removeClass("hideElement");
	$(".formField-photoLoader-button", elementContent).css({"width": "calc(100% - 56px - 18px)"})
}

})(jQuery);
